"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**Obtiene todas las filas que se van a mostrar en un tree */
function getTreeRows(basePath, node, collapsedPaths) {
    const ret = [];
    //Ruta del elemento
    const path = [...basePath, node.key];
    const isLeaf = !node.children || node.children.length == 0;
    const collapsed = isLeaf ? "leaf" :
        (isCollapsed(path, collapsedPaths) ? "collapsed" : "expanded");
    const value = node.value;
    //Agregamos al elemento
    if (basePath.length > 0)
        ret.push({ collapsed, path, value });
    //Agregamos a todos los hijos:
    if (collapsed == "expanded" && node.children) {
        for (const child of (node.children)) {
            ret.push(...getTreeRows(path, child, collapsedPaths));
        }
    }
    return ret;
}
exports.getTreeRows = getTreeRows;
/**Devuelve el nuevo valor para el arreglo de elementos colapsados dada la ruta y el valor de colapsado de un evento de colapsar o expandir */
function handleOnCollapsedChange(path, value, oldValue) {
    let newValue;
    if (!value) {
        //Quitar el elemento:
        newValue = oldValue.filter(x => !sequenceEquals(x, path));
    }
    else {
        //Agregar el elemento.
        newValue = [...oldValue, path];
    }
    return newValue;
}
exports.handleOnCollapsedChange = handleOnCollapsedChange;
/**Devuelve true si una ruta del arbol esta colapsada */
function isCollapsed(path, collapsedArray) {
    return any(collapsedArray, x => sequenceEquals(x, path));
}
exports.isCollapsed = isCollapsed;
/**Devuelve true si 2 secuencias contienen a los mismos elementos */
function sequenceEquals(a, b) {
    //Reference equals
    if (a === b)
        return true;
    if (a.length != b.length)
        return false;
    for (let i = 0; i < a.length; i++) {
        if (a[i] != b[i])
            return false;
    }
    return true;
}
exports.sequenceEquals = sequenceEquals;
/**Devuelve true si algun elemento encaja con el predicado */
function any(array, pred) {
    for (const a of array) {
        if (pred(a))
            return true;
    }
    return false;
}
exports.any = any;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/treeview/logic.js
// module id = 2261
// module chunks = 0